<mat-form-field
  [class.light-form-field]="lightFormField"
  data-cy="job-type-multiselect">
  <mat-label>{{
    label || ("jobType" | i18n) || "Jobtype" | titlecase
  }}</mat-label>

  <mat-select
    [ngModel]="selectedJobTypes"
    (ngModelChange)="onSelectionChange($event)"
    [disabled]="disabled"
    multiple
    data-cy="job-type-multiselect-input">
    <mat-option value="ALL">{{
      ("all" | i18n) || "Alle" | titlecase
    }}</mat-option>
    <mat-divider></mat-divider>
    <mat-option
      *ngFor="let jobType of jobTypeEnum | enumToArray"
      [value]="jobTypeEnum[jobType]"
      [attr.data-cy]="'job-type-option-' + jobTypeEnum[jobType]">
      {{ ("jobTypeEnum." + jobTypeEnum[jobType] | i18n) || jobType }}
    </mat-option>
  </mat-select>
</mat-form-field>
